import { useRoute } from 'vue-router';
import { computed, ref } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { canHaveGlobalBanner } from '@/global-banner/global-banner.utils';
import {
    sideNavCollapsedWidth,
    sideNavExpandedWidth,
    sideNavCollapsedWidthSmallScreen,
    topNavHeight,
    appFrameInset,
    appShellBorderWidth,
    appShellBorderRadius,
} from '@/constants/nav';
import { useLeftNavStore } from '@/stores/left-nav.store';
import { shouldShowNavItems } from '@/vue-router/route.utils';

export function useFixedStyles () {
    const currentRoute = useRoute();
    const leftNavStore = useLeftNavStore();

    const isNavExpanded = computed(() => leftNavStore.expanded);
    const topBannerHeight = computed(() => leftNavStore.topBannerHeight);
    const isTopBannerDismissed = computed(() => leftNavStore.isTopBannerDismissed);
    const shouldGlobalBannerShow = computed(() =>
        canHaveGlobalBanner({
            isTopBannerDismissed,
            currentRoute: currentRoute?.name,
        }),
    );
    const pendoPageRightMargin = ref(0);
    const { width: windowWidth } = useWindowSize();
    const isAppFrameActive = computed(() => shouldShowNavItems(currentRoute, true));
    const appFrameInsetWithBorder = computed(() =>
        (isAppFrameActive.value ? appFrameInset + appShellBorderWidth : 0));
    const topOffset = computed(() => {
        let top = appFrameInsetWithBorder.value + topNavHeight;

        if (shouldGlobalBannerShow.value) {
            top += topBannerHeight.value;
        }

        return top;
    });

    const leftNavWidth = computed(() => {
        if (windowWidth.value < 992) {
            return sideNavCollapsedWidthSmallScreen;
        }

        return isNavExpanded.value ? sideNavExpandedWidth : sideNavCollapsedWidth;
    });

    const affixStyles = computed(() => {
        return {
            fixedStyles: {
                left: leftNavWidth.value + (isAppFrameActive.value ? appShellBorderWidth : 0),
                right: pendoPageRightMargin.value + appFrameInsetWithBorder.value,
                top: topOffset.value,
            },
            shouldAffix: true,
        };
    });

    const drawerStyles = computed(() => {
        return {
            top: topOffset.value,
            right: appFrameInsetWithBorder.value,
            bottom: appFrameInsetWithBorder.value,
            pushDrawerShellChrome: isAppFrameActive.value,
            pushDrawerShellBorderRadiusPx: appShellBorderRadius,
        };
    });

    const setPendoPageRightMargin = (value) => {
        pendoPageRightMargin.value = windowWidth.value - leftNavWidth.value - value;
    };

    return {
        leftNavWidth,
        affixStyles,
        drawerStyles,
        pendoPageRightMargin,

        setPendoPageRightMargin,
    };
}
